import { render, staticRenderFns } from "./sim.vue?vue&type=template&id=d3aa3a16"
import script from "./sim.vue?vue&type=script&lang=js"
export * from "./sim.vue?vue&type=script&lang=js"
import style0 from "./sim.vue?vue&type=style&index=0&id=d3aa3a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports